import { createContractRequest } from './helper';
export const deleteParticipantRole = createContractRequest({
    route: '/contract/offers/:offerId/participantRoles/:roleId',
    method: 'delete',
    source: 'data',
});
